module.exports = __webpack_public_path__ + "static/media/404_page_not_found_iso.b247d793.svg";